'use client';

import { Divider, Stack, Typography, useBreakpoints } from '@castlery/fortress';
import { GlobalReview } from '@castlery/modules-product-domain';
import { Rating } from '@castlery/shared-components';
import { CountryCodeToName, parseReviewsDate } from '@castlery/utils';
import { ProductReviewsItemContent } from './product-reviews-item-content';
import { ProductReviewsItemReply } from './product-reviews-item-reply';

interface ProductReviewsItemProps {
  review: GlobalReview;
}

export function ProductReviewsItem(props: ProductReviewsItemProps) {
  const { review } = props;
  const { desktop } = useBreakpoints();

  const formattedDate = review?.created_at ? parseReviewsDate(review?.created_at) : '';

  return (
    <>
      <Stack
        direction={desktop ? 'row' : 'column'}
        alignItems={desktop ? 'flex-start' : 'center'}
        sx={(theme) => ({
          width: '100%',
          marginTop: desktop ? theme.spacing(7) : theme.spacing(5),
          marginBottom: desktop ? theme.spacing(8) : theme.spacing(5),
        })}
        gap={(theme) => (desktop ? theme.spacing(8) : theme.spacing(5))}
      >
        <Stack
          direction={desktop ? 'column' : 'row'}
          alignItems={desktop ? 'flex-start' : 'center'}
          justifyContent={desktop ? 'center' : 'space-between'}
          flex={1}
          gap={(theme) => (desktop ? theme.spacing(4) : undefined)}
          sx={(theme) => ({
            width: '100%',
          })}
        >
          <Stack alignItems={'flex-start'}>
            <Typography level="body1" mb={(theme) => theme.spacing(1)}>
              {review?.user_name}
            </Typography>
            <Rating
              rating={review?.rating}
              size={15}
              innerType="outline"
              innerColor={'#A45B37'}
              outerColor={'transparent'}
            />
          </Stack>
          <Stack alignItems={'flex-start'}>
            <Typography
              level="caption1"
              mb={(theme) => theme.spacing(1)}
              sx={{
                color: 'var(--fortress-palette-brand-mono-700)',
              }}
            >
              {CountryCodeToName[review?.country as keyof typeof CountryCodeToName]}
            </Typography>
            {review?.is_featured === true && desktop && (
              <Typography
                level="caption1"
                sx={{
                  color: 'var(--fortress-palette-brand-mono-700)',
                }}
              >
                Top Review
              </Typography>
            )}
            {!desktop && (
              <Typography
                level="subh3"
                sx={{
                  color: 'var(--fortress-palette-brand-mono-700)',
                }}
              >
                {formattedDate?.toUpperCase()}
              </Typography>
            )}
          </Stack>
        </Stack>

        <Stack
          flex={desktop ? 6.28 : 'none'}
          sx={{
            width: '100%',
            minWidth: 0,
          }}
        >
          <Stack
            direction="row"
            justifyContent="space-between"
            sx={(theme) => ({
              marginBottom: desktop ? theme.spacing(4) : theme.spacing(2),
            })}
          >
            <Typography level="h4">{review?.title}</Typography>
            {desktop && (
              <Typography
                level="subh3"
                sx={{
                  color: 'var(--fortress-palette-brand-mono-700)',
                }}
              >
                {formattedDate?.toUpperCase()}
              </Typography>
            )}
          </Stack>
          <ProductReviewsItemContent review={review} />
        </Stack>
      </Stack>

      <ProductReviewsItemReply replies={review?.replies} />
      <Divider />
    </>
  );
}
